import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getAccessToken, withReauth } from '@adthlete/shared-frontend'

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

const apiBaseQuery = withReauth(
  fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers) => {
      const token = getAccessToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
)

/** The base query every API slice uses: the real backend, or fixtures with VITE_MOCK_STATE=true. */
export const baseQuery: typeof apiBaseQuery = isMockMode
  ? ((async (args, api, extraOptions) => {
      // Dynamic import: with VITE_MOCK_STATE unset the branch is dead, so the fixtures never ship
      const { mockBaseQuery } = await import('../mock/handlers')
      return mockBaseQuery(args)
    }) as typeof apiBaseQuery)
  : apiBaseQuery
